import { useLocation } from "react-router-dom";

import useHub from "data/hub/useHub";

import { SCREEN_TYPE } from "../../Container";

export function useHubComponentManager({
  workflowLength,
  isViewActive,
  activeScreen = SCREEN_TYPE.WORKFLOW,
}) {
  const hub = useHub();
  const location = useLocation();

  return {
    showButton: {
      filters: workflowLength > 0 && activeScreen !== SCREEN_TYPE.INSIGHTS,
      clearAll:
        (workflowLength > 0 || isViewActive) &&
        activeScreen !== SCREEN_TYPE.INSIGHTS,
      createOrSaveView:
        workflowLength > 0 && activeScreen !== SCREEN_TYPE.INSIGHTS,
    },
    showWidget: {
      useCases: Boolean(hub?.useCases?.visible),
      onboardingContent:
        !hub?.useCases?.visible &&
        location?.pathname.endsWith("/welcome/education"),
    },
    showWorkspace: workflowLength > 0,
  };
}

export default useHubComponentManager;
